var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('iframe',{attrs:{"width":"100%","src":"https://portal.prodpad.com/3404c322-0338-11eb-b9fa-06df22ffaf6f"}})])}]

export { render, staticRenderFns }